export default __webpack_public_path__ + "static/media/content_copy.2f646a83.svg";